<template>
  <div class="footer">
    <div class="inner_footer">
      <div
        class="footer_fourth"
        v-for="(section, index) in internalFooterLinks"
        :key="index"
      >
        <h1>
          {{ section.headingText }}
        </h1>
        <li v-for="(link, index) in section.linkData" :key="index">
          <router-link :to="link.path" :class="link.symbol">
            {{ link.text }}
          </router-link>
        </li>
      </div>
      <div class="footer_fourth">
        <h1>
          {{ externalFooterLinks.headingText }}
        </h1>
        <div class="socialMediaIcons">
          <li
            v-for="(link, index) in externalFooterLinks.linkData"
            :key="index"
          >
            <!--<router-link
                            :to="link.path"
                            :class="link.symbol"
                            >
                        </router-link>
-->
            <a :href="link.path" target="_blank">
              <i :class="link.symbol"> </i>
            </a>
          </li>
        </div>
      </div>
      <div class="footer_fourth">
        <div class="copyright">
          &#169; {{ copyrightYear + " " + companyName }}
        </div>
        <br />
        <router-link :to="privacyPolicy.path">
          {{ privacyPolicy.text }}
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  props: [
    "companyName",
    "internalFooterLinks",
    "externalFooterLinks",
    "copyrightYear",
    "privacyPolicy",
  ],
};
</script>
<style scoped lang="scss">
a,
a:visited,
a:hover,
a:link,
a:active {
  color: inherit;
  text-decoration: none;
}

.footer {
  width: 100%;
  display: flex;
  padding: 20px 0;
  box-sizing: border-box;
  /*screen width minus 70px rather than plus*/
  background-color: #141a3c;
}

.inner_footer {
  display: flex;
  margin: 0 auto;
  width: 1100px;
  height: 100%;
  flex-wrap: wrap;
  justify-content: space-between;
}

.inner_footer .footer_fourth {
  min-width: 200px;
  padding: 0 30px;
  height: 100%;
  color: white;
}

.inner_footer .footer_fourth:last-child {
  margin-right: 20px;
}

.inner_footer .footer_fourth {
  h1 {
    text-align: left;
    font-size: 18px;
    color: white;
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  a {
    font-size: 16px;
    color: white;
    display: block;
    font-weight: 200;
    width: 100%;
    margin-bottom: 5px;
    text-align: left;
  }

  li {
    color: white;
    display: block;
    font-weight: 200;
    width: 100%;
    margin-bottom: 5px;
    text-align: left;
  }

  .socialMediaIcons a {
    font-size: 20px;
  }

  .copyright {
    margin-top: 0px;
    font-size: 16px;
    color: white;
    display: block;
    font-weight: 200;
    width: 100%;
    text-align: left;
  }

  i {
    font-size: 22px;
  }
}

.socialMediaIcons {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

@media all and (max-width: 900px) {
  .inner_footer .footer_fourth {
    margin-bottom: 10px;
    h1 {
      margin-bottom: 5px;
    }
  }
}
</style>
